import { CustomSpin } from '@amili-v3/amili-v3-design';
import { Badge, Tooltip } from 'antd';
import { MenuItemWithBadgeWrapper } from './styles';
import { MouseEvent, memo } from 'react';

type MenuItemWithBadgeLabelProps = {
  loading: boolean;
  label: string;
  badgeNumber?: number;
  backgroundColor: string;
  // Explains what the number counts, shown on badge hover
  badgeTooltip?: string;
  // Clicking the badge itself (not the menu label) - e.g. to open the
  // module pre-filtered to what the number counts
  onClickBadge?: () => void;
};

const MenuItemWithBadgeLabel = ({
  loading,
  label,
  badgeNumber,
  backgroundColor,
  badgeTooltip,
  onClickBadge,
}: MenuItemWithBadgeLabelProps) => {
  const handleClickBadge = (e: MouseEvent<HTMLSpanElement>) => {
    if (!onClickBadge) return;
    // Keep the Menu's own item click (plain navigation) from also firing
    e.stopPropagation();
    onClickBadge();
  };

  return (
    <MenuItemWithBadgeWrapper $backgroundColor={backgroundColor}>
      {label}
      {loading ? (
        <CustomSpin spinning={loading} />
      ) : (
        <Tooltip title={badgeNumber ? badgeTooltip : undefined}>
          <span
            onClick={handleClickBadge}
            style={{ cursor: onClickBadge ? 'pointer' : undefined }}
          >
            <Badge count={badgeNumber} />
          </span>
        </Tooltip>
      )}
    </MenuItemWithBadgeWrapper>
  );
};

export default memo(MenuItemWithBadgeLabel);
